import { Component } from 'react';
import PropTypes from 'prop-types';
import { getEventLinks } from '../../helpers/event-search';
// import Log from '../../utils/debug';

const Log = console;

const CURRENT_CONTEXT = 'EventLinksCellRenderer -> ';

class EventLinksCellRenderer extends Component {
  render() {
    // TODO: props validation
    const { value, data } = this.props;
    Log.info(`${CURRENT_CONTEXT}render (props for event_links)`, value);
    return getEventLinks(value, data.event_id, data.skybox_sales_link, data.reps_links);
  }
}

EventLinksCellRenderer.propTypes = {
  value: PropTypes.array.isRequired,
  data: PropTypes.any.isRequired,
};

export default EventLinksCellRenderer;
